import { getAPI } from '../apiMethods';

export const RUBRIC_CATEGORY_API = {
  rubricCategoryList: () =>
    getAPI(`/api/v1/facebook-meta-ads/rubric_categories/`),
};
